// extracted by mini-css-extract-plugin
export default {"tabs_wrapper":"styles_tabs_wrapper__3PoBH","filters":"styles_filters__r3LRU","filters_button":"styles_filters_button__drVTL"};